import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';
import alta_logo from '../images/alta_logo.png';
import alta_logo_gray from '../images/alta_logo_gray.png';
import menu_icon from '../images/Menu_Bars.png';
import menu_icon_alt from '../images/Menu_Bars_Red.png';
class Header extends Component {

  static propTypes = {
    white: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = {
      top: true,
      isOpen: false
    };
    this.mounted = false;
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll(event) {
    const pos = window.scrollY;
    const oldTop = this.state.top;
    const top = (pos < 1);
    if (top !== oldTop) {
      this.setState({top});
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    const {white} = this.props;
    let menustate = "main-menu fixed-top";
    let altalogo = alta_logo;
    let menubars = menu_icon;
    if (!this.state.top || white || this.state.isOpen) {
      menustate = "main-menu-scrolled fixed-top";
      altalogo = alta_logo_gray;
      menubars = menu_icon_alt;
    }

    return (
      <div>
        <Navbar expand="md" className={menustate}>
          <NavbarBrand href="/"><img src={altalogo} className="logo" alt="Alta Ventures" /></NavbarBrand>
          <NavbarToggler onClick={this.toggle} ><img src={menubars} className="menu-button" alt="Menu" /></NavbarToggler>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem className="d-md-none">
                <NavLink href="/">Home</NavLink>
              </NavItem>
              <NavItem className="d-md-none">
                <NavLink href="/team/">Team</NavLink>
              </NavItem>
              <NavItem className="d-md-none">
                <NavLink href="/companies/">Companies</NavLink>
              </NavItem>
              <NavItem className="d-md-none">
                <NavLink href="/#contact">Contact</NavLink>
              </NavItem>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <img src={menubars} className="menu-button d-none d-md-block" alt="Menu" />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem href="/">
                    Home
                  </DropdownItem>
                  <DropdownItem href="/team">
                    Team
                  </DropdownItem>
                  <DropdownItem href="/companies">
                    Companies
                  </DropdownItem>
                   <DropdownItem href="/#contact">
                    Contact
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header/index.js